const welcome = {
    title: 'Witaj w konsoli administracyjnej',
    description: 'Konsola administracyjna to aplikacja internetowa umożliwiająca zarządzanie Logto bez wymagania znajomości kodowania. Najpierw załóż konto. Dzięki temu kontu możesz zarządzać Logto samodzielnie lub w imieniu swojej firmy.',
    create_account: 'Załóż konto',
};
export default welcome;
